<div class="title-container">
  <div class="title">{{ 'ADD_KNOWLEDGE' | translate }}</div>
</div>
<div>
  <mat-dialog-content>
    <div class="choices-container">
      @for (choice of availableChoices(); track choice) {
        <mat-card class="choice-card" (click)="selectComponent(choice)">
          <mat-card-content>
            <h3 class="choice-title">{{ choice.title | translate }}</h3>
            <p class="description">
              {{ choice.description | translate }}
            </p>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="card-actions__primary">
      <button mat-stroked-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
    </div>
  </mat-dialog-actions>
</div>
